import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";

import { Router } from "@angular/router";

import "rxjs/Rx";

import { Subject } from "rxjs/Subject";
import { environment } from "../../../environments/environment";
import { AuthHttp } from "angular2-jwt";

@Injectable()
export class PVService {
    constructor(private http: Http, private authHttp: AuthHttp, private router: Router) { }

    personReportEmailed = new Subject();
    emailPersonReport(clientId: number, canViewPersonPhoto: any, canViewSuspensions: any, canViewConvictions: any, appUserId: number, email: string) {
        const qs = environment.apiPath + '/api/Enforcement/EmailPersonReport';

        const postObj = {
            languageId: 1,
            user: 'WEB',
            dateFormat: 'dd MMM yyyy',
            isPictureVisible: canViewPersonPhoto,
            isSuspensionVisible: canViewSuspensions,
            isConvictionVisible: canViewConvictions,
            clientId: clientId,
            appUserId: appUserId,
            email: email
        }

        return this.authHttp.post(qs, postObj)
            .map(
            (response: Response) => {
                return response.json();
            })
            .subscribe(
            (response: any) => {
                this.personReportEmailed.next(response);
            },
            (error: Error) => {
                this.personReportEmailed.next(null);
            });
    }
    
    vehicleReportEmailed = new Subject();
    emailVehicleReport(registrationId: number, canViewPersonPhoto: any, canViewSuspensions: any, canViewConvictions: any, appUserId: number, email: string) {
        const qs = environment.apiPath + '/api/Enforcement/EmailVehicleReport';

        const postObj = {
            languageId: 1,
            user: 'WEB',
            dateFormat: 'dd MMM yyyy',
            isPictureVisible: canViewPersonPhoto,
            isSuspensionVisible: canViewSuspensions,
            isConvictionVisible: canViewConvictions,
            registrationId: registrationId,
            appUserId: appUserId,
            email: email
        }

        return this.authHttp.post(qs, postObj)
            .map(
            (response: Response) => {
                return response.json();
            })
            .subscribe(
            (response: any) => {
                this.vehicleReportEmailed.next(response);
            },
            (error: Error) => {
                this.vehicleReportEmailed.next(null);
            });
    }

    //client
    selectedClient: { clientId: number, requestedFrom: string } = { clientId: 0, requestedFrom: '' };

    clearSelectedClient() {
        this.selectedClient = { clientId: 0, requestedFrom: '' };
    }

    setSelectedClient(id: number, from: string) {
        this.selectedClient = { clientId: id, requestedFrom: from };
        this.router.navigate(['/person']);
    }

    isClientSelected() {
        return this.selectedClient.clientId > 0;
    }

    getSelectedClient() {
        return this.selectedClient;
    }


    //vehicle
    selectedVehicle: { registrationId: number, requestedFrom: string } = { registrationId: 0, requestedFrom: '' };

    clearSelectedVehicle() {
        this.selectedVehicle = { registrationId: 0, requestedFrom: '' };
    }

    setSelectedVehicle(id: number, from: string) {
        this.selectedVehicle = { registrationId: id, requestedFrom: from };
        this.router.navigate(['/search']);
    }

    isVehicleSelected() {
        return this.selectedVehicle.registrationId > 0;
    }

    getVehicle() {
        return this.selectedVehicle;
    }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/nonanon/pv.service.ts